import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PrimaryGridAction } from '../../models/grid-toolbar-options';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-primary-grid-action',
    templateUrl: './primary-grid-action.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButton],
})
export class PrimaryGridActionComponent {
    @Input() primaryGridAction?: PrimaryGridAction = undefined;
}
